module.exports = __webpack_public_path__ + "static/img/p_home_wifi.7dcaf166.png";